import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * An eased setter for a CSS custom property. GSAP tweens a plain number and the
 * value is written back with its unit, which keeps pointer effects on the single
 * gsap ticker instead of a hand-rolled rAF loop.
 */
export function quickVar(
  el: HTMLElement,
  property: string,
  unit = '',
  duration = 0.25,
): (value: number) => void {
  const state = { value: 0 };

  const tween = gsap.quickTo(state, 'value', {
    duration,
    ease: 'power3.out',
    onUpdate: () => el.style.setProperty(property, `${state.value.toFixed(2)}${unit}`),
  });

  return (value: number) => {
    tween(value);
  };
}

export { gsap, ScrollTrigger };
